import { NgModule } from '@angular/core';
import { NimbusCacheModule } from './nimbus-cache.module';
import { CacheConfiguration } from './services/models/cache.configuration';
import { CacheStoragesEnum, I_CACHE_LOGGER } from './services/models/cache.models';

export function cacheConfigurationBrowserFactory() {
  return new CacheConfiguration(CacheStoragesEnum.HYBRID, CacheStoragesEnum.SESSION_STORAGE, CacheStoragesEnum.MEMORY);
}

@NgModule({
  imports: [NimbusCacheModule],
})
export class NimbusCacheBrowserModule {
  public static forRoot(loggerType: any) {
    return {
      ngModule: NimbusCacheBrowserModule,
      providers: [
        {
          provide: CacheConfiguration,
          useFactory: cacheConfigurationBrowserFactory,
        },
        { provide: I_CACHE_LOGGER, useExisting: loggerType },
      ],
    };
  }
}
